import { useEffect, useState } from "react";
import { Row, Col, Table, Spinner, Form } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './LicitacoesContratos.css';
import debounce from 'lodash.debounce';
//import CleanPagination from '../Components/CleanPagination';

export default function Licitações() {
    let [licitacoes, setLicitacoes] = useState([]);
    let [loading, setLoading] = useState(true);
    let [page, setPage] = useState(0);

    let [ordenacao, setOrdenacao] = useState({
        campo: "NUMEROPROCESSO",
        ordem: "DESC"
    });

    let [formData, setFormData] = useState({
        ano: "",
        texto: "",
        modalidade: "",
        ordenacao: "NUMEROPROCESSODESC"
    });
    let years = [];
    let currentYear = new Date().getFullYear();
    
    while (currentYear > 2012) {
        years.push(currentYear);
        currentYear--;
    } 

    const modalidades = ["Concorrência",
        "Convite",
        "Dispensa",
        "Inexigibilidade",
        "Leilão",
        "Pregão Eletrônico",
        "Pregão Presencial",
        "Tomada de Preços"];

    const previousPage = () => {
        setPage(page - 1);
    };

    const nextPage = () => {
        setPage(page + 1);
    };

    const getData = () => {
        setLoading(true);
        fetch(`https://www.alepe.pe.gov.br/licitacoes/list.php?pagina=${page}&ano=${formData.ano}&texto=${formData.texto}&modalidade=${formData.modalidade}&ordenacao=${formData.ordenacao}`).then(result => {
            result.json().then((jsonResult) => {
                setLicitacoes(jsonResult.data);
                setLoading(false);
            });
        });
    }

    useEffect(() => {
        getData();
    }, [formData, page]);

    useEffect(() => {
        setFormData({...formData, ordenacao: (ordenacao.campo + ordenacao.ordem)})
    }, [ordenacao]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const debouncedHandleInputChange = debounce(handleInputChange, 500);

    const handleInputChangeOrdenacao = (e) => {
        const { name, value } = e.target;
        setOrdenacao({ ...ordenacao, [name]: value });
    };

    return <Row>
    <Col xs="12">
        <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Licitações</small></p>
    </Col>
        <Col xs="12" style={{height: '25px'}}>
            <p>Filtros de Busca</p>
        </Col>
        <Col xs="12" className="mb-2">
            <Form onSubmit={(e) => {
                    e.preventDefault(); // Prevent the default form submission
                    //getData(); // Call your getData function here
                }}>
                <Row>
                    <Col xs="2">
                        <Form.Group controlId="ano">
                            <Form.Control
                                as="select"
                                name="ano"
                                onChange={handleInputChange}
                                style={{ height: '38px' }}
                            >
                                <option value="">Ano</option>
                                { years.map((year) => { return <option key={year} value={year}>{year}</option>})}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs="7">
                        <Form.Group controlId="texto">
                            <Form.Control
                                type="text"
                                name="texto"
                                placeholder="Busca por texto"
                                onChange={debouncedHandleInputChange}
                                style={{ height: '38px' }}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs="3">
                        <Form.Group controlId="modalidade">
                            <Form.Control
                                    as="select"
                                    name="modalidade"
                                    onChange={handleInputChange}
                                    style={{ height: '38px' }}
                                >
                                    <option value="">Modalidade</option>
                                    { modalidades.map((modalidade) => { return <option key={modalidade} value={modalidade}>{modalidade}</option>})}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    {/*<Col xs="2">
                        <Button className="button" type="submit">
                            Buscar
                        </Button>
                    </Col>*/}
                </Row>
            </Form>
        </Col>
        <Col xs="12" style={{height: '25px'}}>
            <p>Ordenar por</p>
        </Col>
        <Col xs="12" className="mb-3">
            <Form onSubmit={(e) => {
                    e.preventDefault(); // Prevent the default form submission
                    //setOrdenacao(); // Call your getData function here
                }}>
                <Row>
                    <Col xs="3">
                        <Form.Group controlId="campo">
                            <Form.Control
                                as="select"
                                name="campo"
                                onChange={handleInputChangeOrdenacao}
                                style={{ height: '38px' }}
                            >
                                <option value="NUMEROPROCESSO">Nº Processo</option>
                                <option value="MODALIDADE">Modalidade</option>
                                <option value="NUMEROMODALIDADE">Nº Modalidade</option>
                                <option value="OBJETO">Objeto</option>
                                <option value="STATUS">STATUS</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs="3">
                        <Form.Group controlId="ordem">
                            <Form.Control
                                as="select"
                                name="ordem"
                                onChange={handleInputChangeOrdenacao}
                                style={{ height: '38px' }}
                            >
                                <option value="DESC">Decrescente</option>
                                <option value="ASC">Ascendente</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </Col>
        <Col xs="12" className="text-center">
            {loading ? <Spinner/> : null}
        </Col>
        <Col xs="12">
            <Row>
                <Col xs={{spam: 2, offset: 10}} className='mb-2 text-center'>
                    <div>
                        <a href="https://www.alepe.pe.gov.br/licitacoes/export.php" title="Download em CSV"><img src="/img/download-csv.png" height="16" width="16" alt=""/>CSV</a>
                    </div>
                </Col>
            </Row>
            <div className="table-responsive">
                <Table striped bordered hover>
                    <thead>
                    <tr>
                        <th>Nº Processo</th>
                        <th>Modalidade</th>
                        <th>Nº Modalidade</th>
                        <th>Objeto</th>
                        <th>STATUS</th>
                    </tr>
                    </thead>
                    <tbody>
                        { licitacoes?.map((licitacao) => {
                            return <tr key={licitacao.ID}>
                                <td style={{ width: '13%'}}><Link to={"/financas/licitacao/" + licitacao.ID} target="_blank">{licitacao.NUMEROPROCESSO + "/" + licitacao.ANOPROCESSO}</Link></td>
                                <td>{licitacao.NOMEMODALIDADE}</td>
                                <td style={{ width: '13%'}}>{licitacao.NUMEROMODALIDADE + "/" + licitacao.ANOPROCESSO}</td>
                                <td>{licitacao.OBJETOCONFORMEEDITAL}</td>
                                <td>{licitacao.SITUACAOLICITACAO}</td>
                            </tr>
                        }) }
                    </tbody>
                </Table>
            </div>
        </Col>
        <Col xs="6" className="text-start">
            {page > 0 ? 
                <a href="#" onClick={(e) => {previousPage();}}>Página Anterior</a>
            : null}
        </Col> 
        <Col xs="6" className="text-end">
            {licitacoes.length == 10 ? 
                <a href="#" onClick={(e) => {nextPage();}}>Próxima Página</a>
            : null}
        </Col> 
        {/*<Col xs="12" className="text-center">
            <CleanPagination
                totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={handlePageSelect}
            />
        </Col>*/}
    </Row>
}